import Flex from '@deprecated-ui/common/Flex';
import Text from '@deprecated-ui/common/Text';
import Iconmoon from '@deprecated-ui/common/Iconmoon';
import { useBondPortfolioStore } from '../../stores/useBondPortfolioStore';
import {
  CouponHistoryContainer,
  ModalBody,
  ModalContainer,
  ModalHeader,
  ModalRoot,
} from '../../styled';
import Summary from './components/Summary';
import HistroyRowGroup from './components/HistoryRowGroup';

interface Props {
  isVisible: boolean;
  onCancel(): void;
}

export default function ModalBondCouponReceipt({
  isVisible,
  onCancel,
}: Readonly<Props>) {
  const [couponHistories] = useBondPortfolioStore((s) => [s.couponHistories]);

  return (
    <ModalRoot visible={isVisible} onCancel={onCancel}>
      <ModalContainer>
        <ModalHeader>
          {/* @ts-expect-error */}
          <Flex justify="between" align="center" w="100%">
            <Text
              family="bold"
              size="18px"
              align="center"
              // @ts-expect-error
              mt="0"
              width="100%"
              data-cy="bonds-modal-header"
            >
              Riwayat Penerimaan Kupon
            </Text>
            <Iconmoon
              className="icon-trading_x"
              color="#333333"
              size="12px"
              onClick={onCancel}
            />
          </Flex>
        </ModalHeader>
        <ModalBody
          css={`
            width: 500px;
          `}
        >
          <Summary
            total={couponHistories?.total}
            accruedInterest={couponHistories.total_user_coupon}
            sellerCoupon={couponHistories.total_seller_coupon}
          />
          <CouponHistoryContainer>
            {couponHistories?.histories?.map((history) => (
              <HistroyRowGroup
                history={history}
                key={`coupon-history-${history.year}`}
              />
            ))}
          </CouponHistoryContainer>
        </ModalBody>
      </ModalContainer>
    </ModalRoot>
  );
}
